module.exports = __webpack_public_path__ + "img/change_password.d089b87e.svg";